import {getBackendAssetUrl, getDateFromIsoString} from '@shared/api';
import {createTranslationDict} from '@shared/helpers';
import {getLocalizedText} from '@shared/utils';
import {Banner, BannerDetail} from '../types';
import {
  AdminBannerDetailOnBackend,
  AdminBannerListOnBackend,
} from './backendTypes';

export const mapAdminBannerFromBackend = ({
  id,
  name,
  logo_url,
  app_url,
  web_url,
  active_from,
  active_to,
  geos,
  order,
}: AdminBannerListOnBackend): Banner => ({
  id,
  name: name ?? '',
  logoUrl: getBackendAssetUrl(logo_url),
  appUrl: app_url ?? null,
  webUrl: web_url ?? null,
  activeFrom: active_from ? getDateFromIsoString(active_from) : null,
  activeTo: active_to ? getDateFromIsoString(active_to) : null,
  geos: (geos ?? []).filter((g): g is string => typeof g === 'string'),
  order: order ?? 0,
});

export const mapAdminBannerDetailFromBackend = ({
  id,
  name,
  logo_url,
  app_url,
  web_url,
  active_from,
  active_to,
  geos,
  order,
}: AdminBannerDetailOnBackend): BannerDetail => ({
  id,
  name: getLocalizedText(name),
  nameTranslations: createTranslationDict(name),
  logoUrl: getBackendAssetUrl(logo_url),
  appUrl: app_url ?? null,
  webUrl: web_url ?? null,
  activeFrom: active_from ? getDateFromIsoString(active_from) : null,
  activeTo: active_to ? getDateFromIsoString(active_to) : null,
  geos: (geos ?? []).filter((g): g is string => typeof g === 'string'),
  order: order ?? 0,
});
